module.exports = __webpack_public_path__ + "img/logo-yza.png";